module.exports = __webpack_public_path__ + "img/wodekefu@2x.89e52d8d.png";